import { X } from "lucide-react";
import { Spinner } from "./ui/spinner";

export const Loading = ({
  message,
  onClose,
}: {
  message?: string;
  onClose?: () => void;
}) => {
  return (
    <div className="flex flex-col gap-5 w-full h-full justify-start items-center p-4">
      <X
        size={16}
        className="cursor-pointer self-end text-muted-foreground"
        style={{ width: '16px !important', height: '16px !important', minWidth: '16px', minHeight: '16px' }}
        onClick={onClose}
      />
      <div className="flex flex-col gap-3 h-full justify-center items-center">
        <Spinner size="md" />
        {message && (
          <p className="text-[13px] text-center text-muted-foreground">
            {message}
          </p>
        )}
      </div>
    </div>
  );
};
